module.exports = __webpack_public_path__ + "img/pv-logo.82fb45cc.svg";